import { render, staticRenderFns } from "./ReportCallAgent.vue?vue&type=template&id=bbddd246"
import script from "./ReportCallAgent.vue?vue&type=script&lang=js"
export * from "./ReportCallAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports